const CONTEXTUAL_CONTACT_DETAILS_ROUTES = {
  contacts_dashboard_segments_index: ['contacts_edit_segment', 'segmentId'],
  contacts_dashboard_labels_index: ['contacts_edit_label', 'label'],
};

export const buildContactDetailsRoute = (route, contactId) => {
  const [name, paramKey] = CONTEXTUAL_CONTACT_DETAILS_ROUTES[route.name] || [
    'contacts_edit',
  ];

  return {
    name,
    params: {
      accountId: route.params.accountId,
      contactId,
      ...(paramKey && { [paramKey]: route.params[paramKey] }),
    },
    query: route.query,
  };
};
